import { Component, OnInit } from "@angular/core";
import {
  ModalController,
  LoadingController,
  NavController,
  Platform,
  MenuController,
} from "@ionic/angular";
import { FinallyRacePage } from "../finally-race/finally-race.page";
import { CrudService } from "src/app/services/crud.service";
import { ResponseAPI } from "src/models/user.model";
import { UtilService } from "src/app/services/util.service";
import { loadingProps } from "src/utils/util.functions";
import { Browser } from "@capacitor/browser";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-current-race",
    templateUrl: "./current-race.page.html",
    styleUrls: ["./current-race.page.scss"],
    standalone: false
})
export class CurrentRacePage implements OnInit {
  race: any = { raceType: "" };
  photobanner = "assets/images/trip-in-progress.jpg";

  constructor(
    private modalCtrl: ModalController,
    public crud: CrudService,
    private util: UtilService,
    public navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private platform: Platform,
    private menuCtrl: MenuController
  ) { }

  ngOnInit() {
    this.race = JSON.parse(localStorage.getItem("currentRace"));
    if (
      this.race.raceType.includes("Round Trip") &&
      this.race.etapaIdaVolta === 1
    ) {
      this.photobanner = "assets/images/rond-trip-return-in-progress.jpg";
    }
  }

  ionViewDidEnter() {
    this.menuCtrl.enable(false);
  }

  async presentModal() {
    const modal = await this.modalCtrl.create({
      component: FinallyRacePage,
      cssClass: "modal-overlay",
    });

    return await modal.present();
  }

  navigate(app: string) {
    const originLat = this.race.latitudeOrigem;
    const originLng = this.race.longitudeOrigem;
    const destLat = this.race.latitudeDestino;
    const destLng = this.race.longitudeDestino;

    switch (app) {
      case "Maps":
        Browser.open({
          url: `https://www.google.com/maps/dir/?api=1&origin=${originLat},${originLng}&destination=${destLat},${destLng}`,
          windowName: "_system"
        }).catch(console.error);
        break;
      case "Waze":
        Browser.open({
          url: `https://www.waze.com/ul?ll=${destLat},${destLng}&navigate=yes`,
          windowName: "_system"
        }).catch(console.error);
        break;
      default:
        Browser.open({
          url: `https://www.google.com/maps/dir/?api=1&origin=${originLat},${originLng}&destination=${destLat},${destLng}`,
          windowName: "_system"
        }).catch(console.error);
    }
  }

  navigateRoundTripReturn(app: string) {
    const destLat = this.race.latitudeOrigem;
    const destLng = this.race.longitudeOrigem;
    const originLat = this.race.latitudeDestino;
    const originLng = this.race.longitudeDestino;

    switch (app) {
      case "Maps":
        Browser.open({
          url: `https://www.google.com/maps/dir/?api=1&origin=${originLat},${originLng}&destination=${destLat},${destLng}`,
          windowName: "_system"
        }).catch(console.error);
        break;
      case "Waze":
        Browser.open({
          url: `https://www.waze.com/ul?ll=${destLat},${destLng}&navigate=yes`,
          windowName: "_system"
        }).catch(console.error);
        break;
      default:
        Browser.open({
          url: `https://www.google.com/maps/dir/?api=1&origin=${originLat},${originLng}&destination=${destLat},${destLng}`,
          windowName: "_system"
        }).catch(console.error);
    }
  }

  async showLoading() {
    loadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.loadingCtrl.create(loadingProps);
    return await loading.present();
  }
  async finishRace(): Promise<void> {
    this.menuCtrl.enable(true);
    await this.showLoading();
    this.crud
      .getData(`${environment.useHubV2 ? 'v2/' : ''}Corrida/finalizar-corrida?id=` + this.race.id, null)
      .subscribe(
        async (response: ResponseAPI) => {
          if (response.success) {
            localStorage.setItem(
              "saldoCorrida",
              JSON.stringify(response.data.saldo)
            );
            await this.loadingCtrl.dismiss();
            if (
              this.race.raceType.includes("Round Trip") &&
              this.race.etapaIdaVolta === 1
            ) {
              await this.navCtrl.navigateForward("driver/queue");
            } else {
              await this.presentModal();
            }
          }
        },
        (error) => {
          this.util.showToast("An error occured");
          this.loadingCtrl.dismiss();
        }
      );
  }
}
